export default theme => ({
  buttonContainer: {
    position: 'fixed',
    color: theme.palette.grey.main,
    zIndex: 20,
    bottom: theme.spacing(2),
    right: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      bottom: theme.spacing(1),
      right: theme.spacing(0.5),
    },
  },
  button: {
    [theme.breakpoints.down('sm')]: {
      width: '40px !important',
      height: '40px !important',
    },
    '& svg': {
      [theme.breakpoints.down('sm')]: {
        width: 18,
      },
    },
  },
});
